import React, { useEffect, useState } from "react";
import "./LoginV3.scss";
import "./PasswordV3.scss";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { FiArrowLeft, FiArrowRight, FiCheckCircle, FiHeadphones, FiLock, FiShield } from "react-icons/fi";
import { usePasswordMutation } from "services/auth";
import Logo from "../../assets/images/logo.png";

const PasswordV3 = () => {
    const [otp, setOtp] = useState("");
    const [loading, setLoading] = useState(false);
    const passcode = localStorage.getItem("passcode");
    const otpPhoneNumber = localStorage.getItem("otp_phone_nr");
    const [submitPassword] = usePasswordMutation();
    const navigate = useNavigate();

    useEffect(() => {
        if (!passcode || !otpPhoneNumber) navigate("/login", { replace: true });
    }, [navigate, passcode, otpPhoneNumber]);

    const handleSubmitPassword = async (event) => {
        event.preventDefault();
        setLoading(true);

        const result = await submitPassword({
            passcode,
            otp_phone_nr: otpPhoneNumber,
            password: otp,
        });

        if ("error" in result) {
            toast.error("The verification code is incorrect or expired. Please try again.");
        } else {
            localStorage.setItem("auth_client", result.data.access_token);
            localStorage.setItem("isClient", true);
            toast.success("Logged in successfully");
            navigate("/");
        }

        setLoading(false);
    };

    const getBaseDomain = () => {
        const parts = window.location.hostname.split(".");
        return parts.length >= 2 ? parts.slice(-2).join(".") : window.location.hostname;
    };

    const maskedPhoneNumber = otpPhoneNumber
        ? `•••• ${otpPhoneNumber.replace(/\s/g, "").slice(-4)}`
        : "your registered phone";

    return (
        <main className="dashboard-login dashboard-login--verify">
            <section className="dashboard-login__intro">
                <a className="dashboard-login__brand dashboard-login__brand--light" href={`https://${getBaseDomain()}`}>
                    <span className="brand-logo-frame"><img src={Logo} alt="Banque Artesia Nederland N.V." /></span>
                </a>

                <div className="dashboard-login__intro-content">
                    <span className="dashboard-login__eyebrow">Identity verification</span>
                    <h1>One last step.<br /><em>Stay protected.</em></h1>
                    <p>We use an additional verification step to make sure it is really you accessing your financial dashboard.</p>

                    <div className="dashboard-login__trust-list">
                        <div><FiShield /><span><strong>Time-sensitive code</strong>Your verification code expires for added security.</span></div>
                        <div><FiCheckCircle /><span><strong>Secure access</strong>Successful verification takes you directly to your dashboard.</span></div>
                    </div>
                </div>

                <p className="dashboard-login__copyright">© Banque Artesia Nederland N.V. {new Date().getFullYear()} · All rights reserved</p>
            </section>

            <section className="dashboard-login__access">
                <div className="dashboard-login__mobile-brand">
                    <span className="brand-logo-frame"><img src={Logo} alt="Banque Artesia Nederland N.V." /></span>
                </div>

                <form className="dashboard-login__form dashboard-login__verify-form" onSubmit={handleSubmitPassword}>
                    <button type="button" className="dashboard-login__back" onClick={() => navigate("/login")}>
                        <FiArrowLeft /> Back to login
                    </button>

                    <div className="dashboard-login__heading">
                        <span className="dashboard-login__step">Secure verification</span>
                        <h2>Check your phone</h2>
                        <p>Enter the one-time code sent to <strong>{maskedPhoneNumber}</strong>.</p>
                    </div>

                    <div className="dashboard-login__otp-icon" aria-hidden="true"><FiLock /></div>

                    <div className="dashboard-login__field dashboard-login__otp-field">
                        <label htmlFor="verification-code">Verification code</label>
                        <input
                            id="verification-code"
                            type="text"
                            name="password"
                            inputMode="numeric"
                            autoComplete="one-time-code"
                            placeholder="Enter your OTP code"
                            value={otp}
                            onChange={(event) => setOtp(event.target.value.replace(/\D/g, ""))}
                            autoFocus
                            required
                        />
                    </div>

                    <button type="submit" className="dashboard-login__submit" disabled={loading}>
                        <span>{loading ? "Verifying code..." : "Verify and continue"}</span>
                        {!loading && <FiArrowRight />}
                    </button>

                    <div className="dashboard-login__security"><FiLock /> Your code is submitted over an encrypted connection</div>

                    <div className="dashboard-login__resend">
                        <p>Didn't receive the code?</p>
                        <button type="button" onClick={() => navigate("/login")}>Return to login and request a new code</button>
                    </div>

                    <div className="dashboard-login__support">
                        <span><FiHeadphones /></span>
                        <div><small>Having trouble with verification?</small><a href={`https://${getBaseDomain()}/contact-us`}>Contact our support team</a></div>
                    </div>
                </form>
            </section>
        </main>
    );
};

export default PasswordV3;
